"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var containsExclusive = function containsExclusive(x, start, end) {
  return x > start && x < end;
};

var _default = containsExclusive;
exports["default"] = _default;